module.exports = __webpack_public_path__ + "static/img/about4.008d877.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/about4.png
// module id = N3WO
// module chunks = 0